import { ReactNode, useRef } from 'react';

import { FilterAltOutlined } from '@mui/icons-material';
import { Box, Button, Divider, Fab } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';

import { BottomSheet } from 'components/docked';
import { Row } from 'components/form';

type FilterMobile = {
    children?: ReactNode;
    open: boolean;
    loadingSubmit?: boolean;
    onOpen: () => void;
    onClose: () => void;
    reset: () => void;
    submit: () => void;
};

export function FilterMobile({ children, open, loadingSubmit = false, onOpen, onClose, reset, submit }: FilterMobile) {
    const refFilter = useRef<HTMLDivElement>(null);

    return (
        <LocalizationProvider adapterLocale={ptBR} dateAdapter={AdapterDateFns}>
            <Fab
                color="primary"
                variant="extended"
                sx={{ top: 16, gap: 1, zIndex: 3, position: 'sticky', alignSelf: 'flex-start' }}
                onClick={() => {
                    if (refFilter.current) refFilter.current.scrollTop = 0;

                    onOpen();
                }}
            >
                <FilterAltOutlined />
                Filtros
            </Fab>

            <BottomSheet
                minHeight={0}
                open={open}
                onClose={onClose}
                onOpen={onOpen}
                bodySx={{ gap: 0 }}
                title={
                    <>
                        <FilterAltOutlined />
                        Filtros
                    </>
                }
            >
                <Row
                    ref={refFilter}
                    sx={{
                        'pb': 2,
                        'mb': 0,
                        'pt': 0.75,
                        '& .MuiGrid-root:empty': { display: 'none' },
                        'flex': 1,
                        'minHeight': 0,
                        'overflowY': 'scroll',
                        'flexWrap': 'nowrap',
                    }}
                >
                    {children}
                </Row>

                <Divider sx={{ mx: -2 }} />

                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                    <Button variant="outlined" onClick={reset} fullWidth>
                        Redefinir
                    </Button>

                    <Button variant="contained" onClick={submit} loading={loadingSubmit} fullWidth>
                        Pesquisar
                    </Button>
                </Box>
            </BottomSheet>
        </LocalizationProvider>
    );
}
